<template>
    <div class="wrapper">
        <div class="top-box">
            <img class="top-img" :data-src="tabList[active_index].img" alt="">
            <div class="tab-btn" @click="showTab = true">
                <img data-src="../../static/mt_img/tab-icon.png" alt="">
            </div>
            <img class="logo-img" data-src="../../static/img/logo.png" alt="">
        </div>
        <div class="tab-pop-box" v-show="showTab" @click="showTab = false">
            <div class="pop-bg"></div>
            <div class="tab-pop">
                <img data-src="../../static/img/logo.png" alt="">
                <div class="tab-list">
                    <div class="tab-item" @click.stop="changeTab(index)" v-for="(item,index) in tabList" :key="index">{{item.text}}</div>
                </div>
            </div> 
        </div>
        <router-view/>
        <div class="bottom-box">
            <div class="bottom-tabs">
                <div class="bottom-left-tab-item" @click="changeTab(index)" v-for="(item,index) in tabList" :key="index">{{item.text}}</div>
            </div>
            <div class="bottom-right">
                <div class="bottom-right-text1">gaowk@qinlianet.com</div>
                <div class="bottom-right-text2">周一至周日 09:30-18:30</div>
            </div>
            <div class="bottom-left-info">
                <div class="bottom-left-text1"><a href="https://beian.miit.gov.cn">沪公网备沪ICP备17002979号-16</a> 经营许可证编号：沪B2-20170190 <img src="../../static/img/bottom-icon.png" alt=""></div>
                <!-- <div class="bottom-left-text2">法律顾问：上海锦天城律师事务所</div> -->
                <div class="bottom-left-text3">©2022 qinliannet.com 勤联（上海勤联物联网有限公司）版权所有</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'mt-tab',
    data(){
        return {
            tabList: [
                {
                    img: require('../../static/mt_img/top-img1.png'),
                    text: '首页',
                    path:'/mt_tab'
                },
                {
                    img: require('../../static/mt_img/top-img2.png'),
                    text: '品牌数字化服务',
                    path:'./mt_number'
                },
                {
                    img: require('../../static/mt_img/top-img5.png'),
                    text: '虚拟运动社交电商',
                    path:'./mt_virtual'
                },
                {
                    img: require('../../static/mt_img/top-img3.png'),
                    text: '链接线下和线上',
                    path:'./mt_linkLine'
                },
                {
                    img: require('../../static/mt_img/top-img4.png'),
                    text: '关于我们',
                    path:'./mt_user'
                }
            ],
            active_index: 0,
            showTab: false
        }
    },
    created(){
        localStorage.setItem('path','./mt_tab')
        let index = Number(localStorage.getItem('index'))
        if(index){
            this.active_index = index
        }else{
            this.active_index = 0
        }
        
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        },
        changeTab(e){
            this.active_index = e
            this.$router.push(this.tabList[this.active_index].path)
            window.scrollTo(0,0);
        }
    }
}
</script>
<style scoped>
.top-box{
    width: 100%;
    position: relative;
}
.top-img{
    width: 100%;
}
.tab-btn{
    position: absolute;
    width: 5.37vw;
    right: 4.5vw;
    top: 4.2vw;
}
.tab-btn > img{
    width: 5.37vw;
}
.logo-img{
    position: absolute;
    left: 4.6vw;
    top: 4vw;
    width: 20vw;
}
.bottom-box{
    width: 100%;
    height: 42.4vw;
    overflow: hidden;
    background: url('../../static/mt_img/bottom-bg.png') no-repeat;
    background-size: 100%;
}
.bottom-tabs{
    margin-top: 4.5vw;
    display: flex;
    margin-left: 4vw;
}
.bottom-left-tab-item{
    margin-right: 4vw;
    font-size: 3.2vw;
    color: #fff;
}
.bottom-right{
    margin-left: 4vw;
    margin-top: 6vw;
}
.bottom-right-text1{
    font-size: 4.72vw;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
}
.bottom-right-text2{
    font-size: 2.67vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.bottom-left-info{
    margin-left: 4vw;
    margin-top: 4.8vw;
    font-size: 2.27vw;
    font-family: PingFang SC;
    color: #A7A9AF;
    line-height: 3vw;
}
.bottom-left-info a{
    color: #A7A9AF;
    font-size: 2.27vw;
    text-decoration: none;
    margin-right: 0.6vw;
}
.tab-pop-box{
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
}
.tab-pop{
    width: 55vw;
    height: 100vh;
    background: rgb(38,41,46);
    position: absolute;
    right: 0;
    top: 0;
}
.tab-pop > img{
    width: 30vw;
    margin: 6vw 12.5vw;
}
.tab-list{
    width: 100%;
    text-align: center;
    margin-top: 10vw;
}
.tab-item{
    color: #fff;
    font-size: 3.2vw;
    margin-bottom: 10vw;
}
.bottom-left-text1{
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.bottom-left-text1 > img{
    width: 2.8vw;
}
/* .pop-bg{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    background: rgba(0,0,0,0.5);
} */
</style>


// WEBPACK FOOTER //
// src/pages/mt_tab.vue